var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { CodeEditor } from './CodeEditor.js';
export const RawCodeEditor = (_a) => {
    var { name, onChange, error, defaultLanguage, value } = _a, rest = __rest(_a, ["name", "onChange", "error", "defaultLanguage", "value"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormControl.Textarea, Object.assign({ name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, value: value, onChange: onChange }, rest, { style: { display: 'none' } })),
        React.createElement(CodeEditor, { initialValue: value, onChange: onChange, defaultLanguage: defaultLanguage })));
};
//# sourceMappingURL=RawCodeEditor.js.map